var audio_rtlignore_default = {
  "fontElementMap": "NgWbo",
  "customPlayer": "IvVGK",
  "customPlayer_basic": "y-KvW",
  "customPlayer_mobile": "lwjyz",
  "audio_coverImg": "FJQMf",
  "audio_small_cover_image": "s1nrt",
  "audio_icon_button": "EjMpn",
  "audio_contextMenu_wrapper": "atpEX",
  "customPlayer_with_image": "HyLYW",
  "track_wrapper": "aUsTd",
  "trackContainer": "_0EM-d",
  "audio_download_icon": "kVTYI",
  "audio_duration": "kw81y",
  "customPlayer_small_fit": "_4EG5f",
  "track_sliders_wrapper": "yVNtd",
  "audio_volume_wrapper": "LO-oI",
  "volume_slider_wrapper": "qdGlL",
  "audioDetails": "be-1M",
  "title": "lz5n-",
  "author_name": "_9UIYH",
  "dropdown_menu_wrapper": "wXEo4",
  "dropdown_selected_button": "_8bPjm",
  "dropdown_content": "vpT4a",
  "dropdown_content_withIcon": "uBDEK",
  "audio_loader_icon": "sSZZd",
  "spin": "fse7t"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
